import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../services/api';

export const useMaintenanceMode = () => {
  const [maintenanceStatus, setMaintenanceStatus] = useState({
    isMaintenanceMode: false,
    hasBypass: false,
    isLoading: true,
    error: null
  });

  // Check if user has bypass in localStorage
  const getStoredBypass = () => {
    const stored = localStorage.getItem('maintenanceBypass');
    if (stored) {
      try {
        const { timestamp } = JSON.parse(stored);
        // Bypass expires after 24 hours
        const isExpired = Date.now() - timestamp > 24 * 60 * 60 * 1000;
        if (!isExpired) {
          return true;
        } else {
          localStorage.removeItem('maintenanceBypass');
        }
      } catch {
        localStorage.removeItem('maintenanceBypass');
      }
    }
    return false;
  };

  const checkMaintenanceStatus = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/maintenance/status`);

      if (response.ok) {
        const data = await response.json();
        const hasStoredBypass = getStoredBypass();
        
        setMaintenanceStatus({
          isMaintenanceMode: data.maintenanceMode,
          hasBypass: hasStoredBypass,
          isLoading: false,
          error: null
        });
      } else {
        // If we can't reach the maintenance endpoint, assume no maintenance mode
        setMaintenanceStatus({
          isMaintenanceMode: false,
          hasBypass: false,
          isLoading: false,
          error: null
        });
      }
    } catch (error) {
      // If there's a network error, assume no maintenance mode to avoid blocking users
      setMaintenanceStatus({
        isMaintenanceMode: false,
        hasBypass: false,
        isLoading: false,
        error: error.message
      });
    }
  };

  const grantBypass = () => {
    // Store bypass in localStorage with timestamp
    localStorage.setItem('maintenanceBypass', JSON.stringify({
      timestamp: Date.now()
    }));
    
    setMaintenanceStatus(prev => ({
      ...prev,
      hasBypass: true
    }));
  };

  useEffect(() => {
    checkMaintenanceStatus();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    ...maintenanceStatus,
    refetch: checkMaintenanceStatus,
    grantBypass
  };
};